{
  "GENERAL": {
    "SHOWING_RESULTS": "Mostrando {firstIndex}-{lastIndex} de {totalCount} elementos",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Buscar",
      "EMPTY_STATE": "No se encontraron resultados"
    },
    "CLOSE": "Cerrar",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "This feature is in beta and may change as we improve it.",
    "ACCEPT": "Accept",
    "DISCARD": "Descartar",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "Si",
    "NO": "No"
  }
}
